import { LocalPoi } from '../interface/LocalPoi';
import { LocalPoiFile } from '../interface/LocalPoiFile';

export const postPoi = async (
  auth: string,
  poi: LocalPoi | null,
  title: string,
  description: string,
  category: string,
  latitude: number,
  longitude: number,
  files: LocalPoiFile[]
): Promise<string> => {
  const { REACT_APP_API_URL } = process.env;
  const method = poi ? 'PUT' : 'POST';
  const url = poi
    ? `${REACT_APP_API_URL}/localpoi/${poi.id}/`
    : `${REACT_APP_API_URL}/localpoi/`;

  try {
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('category.name', category);
    formData.append('latitude', parseFloat(latitude.toFixed(7)).toString());
    formData.append('longitude', parseFloat(longitude.toFixed(7)).toString());

    files.forEach((fileObj, index) => {
      if (fileObj.id) {
        formData.append(`files[${index}].id`, fileObj.id.toString());
      } else if (fileObj.file) {
        formData.append(`files[${index}].name`, fileObj.file.name);
        formData.append(`files[${index}].file`, fileObj.file);
      }
    });

    const response = await fetch(url, {
      method: method,
      headers: {
        Authorization: auth,
      },
      body: formData,
    });

    if (response.ok) {
      return 'Local POI saved successfully';
    } else {
      return `${response.status} ${response.statusText}`;
    }
  } catch (error) {
    return (error as Error).message || 'Unknown error';
  }
};
